import React from "react";
import PropTypes from "prop-types";
import SortableHeader from "../../../../components/atoms/SortableHeader";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import {
  compareByProperty,
  sortRefs,
} from "../../../../common/helpers/sortingHelpers";

const labels = {
  disease: "Disease",
  verdict: "Verdict",
  expert_panel: "Expert Panel",
  inheritance: "Inheritance",
  pub_med_references: "Pubmed References",
};

function GenCCTable({ items, sortedField, isAsc, toggleField, publications }) {
  return (
    <div className="tw-overflow-y-auto tw-ml-0 tw-mb-8">
      <table className="varsome-table varsome-table-sorted">
        <thead>
          <tr>
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="disease"
              width="20%"
            />
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="verdict"
              width="20%"
            />
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="expert_panel"
              width="15%"
            />
            <SortableHeader
              sort={(key) => toggleField(compareByProperty(key), key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="inheritance"
              width="30%"
            />
            <SortableHeader
              sort={(key) => toggleField(sortRefs, key)}
              labels={labels}
              sortedField={sortedField}
              isAsc={isAsc}
              field="pub_med_references"
              width="15%"
            />
          </tr>
        </thead>
        <tbody>
          {items.map((x, index) => {
            return (
              <tr key={`${x.disease}-${index}`}>
                <td>{x.disease}</td>
                <td>{x.verdict}</td>
                <td>{x.expert_panel}</td>
                <td>{x.inheritance}</td>
                <td className="varsome-text-center">
                  {x.pub_med_references ? (
                    <PublicationLinks
                      ids={x.pub_med_references}
                      details={publications}
                    />
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

GenCCTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      disease: PropTypes.string,
      verdict: PropTypes.string,
      expert_panel: PropTypes.string,
    })
  ),
  sortedField: PropTypes.string,
  isAsc: PropTypes.bool,
  toggleField: PropTypes.func.isRequired,
  publications: PropTypes.arrayOf(PropTypes.string),
};

GenCCTable.defaultProps = {
  items: null,
  sortedField: null,
  isAsc: true,
  publications: null,
};

export default GenCCTable;
